import { render, staticRenderFns } from "./IbCardEmptyState.vue?vue&type=template&id=318d2080&scoped=true"
import script from "./IbCardEmptyState.vue?vue&type=script&lang=js"
export * from "./IbCardEmptyState.vue?vue&type=script&lang=js"
import style0 from "./IbCardEmptyState.vue?vue&type=style&index=0&id=318d2080&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318d2080",
  null
  
)

export default component.exports